import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { globalModel } from "../../global/GlobalModel";
import { StoreOrderDetailPanel } from "../../customer_account/StoreOrderDetailPanel";
import { ShellTopBar } from "../shell/ShellTopBar";
import "../../customer_account/AccountPage.css";

export default function CheckoutPage(): JSX.Element | null {
  const { spaceId, orderId } = useParams<{ spaceId: string; orderId: string }>();
  const navigate = useNavigate();
  const onMissingParams = useCallback(() => navigate("/"), [navigate]);

  if (!spaceId || !orderId) {
    return null;
  }

  return (
    <div className="customer-account-page">
      <ShellTopBar onLoginClick={() => globalModel.openLoginModal()} />
      <main className="customer-account-page__main customer-account-page__main--below-fixed-top customer-account-page__main--order-detail">
        <StoreOrderDetailPanel
          spaceId={spaceId}
          orderId={orderId}
          scope="platform"
          onMissingParams={onMissingParams}
        />
      </main>
    </div>
  );
}
